import { service_const } from './consts'
import { CodeToText, TextToCode } from '@/assets/js/app'


export function menoyToUppercase(money) {
  var cnNums = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖');	 //汉字的数字
  var cnIntRadice = new Array('', '拾', '佰', '仟'); //基本单位
  var cnIntUnits = new Array('', '万', '亿', '兆');  //对应整数部分扩展单位
  var cnDecUnits = new Array('角', '分', '毫', '厘'); //对应小数部分单位
  var cnInteger = '整';	//整数金额时后面跟的字符
  var cnIntLast = '元';	//整数完以后的单位
  //最大处理的数字
  var maxNum = 999999999999999.9999;
  var integerNum;	 //金额整数部分
  var decimalNum;	 //金额小数部分
  //输出的中文金额字符串
  var chineseStr = '';
  var parts;		//分离金额后用的数组，预定义
  if (money == '') { return ''; }

  money = parseFloat(money);
  if (money >= maxNum) {
      //超出最大处理数字
      return '超出最大处理数字';
  }
  if (money == 0) {
      chineseStr = cnNums[0] + cnIntLast + cnInteger;
      return chineseStr;
  }
  //四舍五入保留两位小数,转换为字符串
  money = Math.round(money * 100).toString();
  integerNum = money.substr(0,money.length-2);
  decimalNum = money.substr(money.length-2);
  //获取整型部分转换
  if (parseInt(integerNum, 10) > 0) {
      var zeroCount = 0;
      var IntLen = integerNum.length;
      for (var i = 0; i < IntLen; i++) {
          var n = integerNum.substr(i, 1);
          var p = IntLen - i - 1;
          var q = p / 4;
          var m = p % 4;
          if (n == '0') {
              zeroCount++;
          } else {
              if (zeroCount > 0) {
                  chineseStr += cnNums[0];
              }
              //归零
              zeroCount = 0;
              chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
          }
          if (m == 0 && zeroCount < 4) {
              chineseStr += cnIntUnits[q];
          }
      }
      chineseStr += cnIntLast;
  }
  //小数部分
  if (decimalNum != '') {
      var decLen = decimalNum.length;
      for (var i = 0; i < decLen; i++) {
          var n = decimalNum.substr(i, 1);
          if (n != '0') {
              chineseStr += cnNums[Number(n)] + cnDecUnits[i];
          }
      }
  }
  if (chineseStr == '') {
      chineseStr += cnNums[0] + cnIntLast + cnInteger;
  } else if (decimalNum == '' || /^0*$/.test(decimalNum)) {
      chineseStr += cnInteger;
  }
  return chineseStr;
}
/**
 * 改变原因
 */
export function changecause(val){
  let str=''
  val.split(',').forEach((item,index)=>{
    
    if((index+1)!== val.split(',').length){
      str+='('+Number(index+1)+')'+item+','
    }else{
      str+=item
    }
  })
  return str
}
/**
 * 判断字符串字节长度，去掉空格
 */
//str = new String(val.replace(/\s*/g,''));  .replace(/[-]/g,'')
export function getStringLength(val) {
  let str = val
  let bytesCount = 0
  for (var i = 0; i < str.length; i++) {
    var charCode = str.charCodeAt(i)
    //  console.log(charCode)
    // if (charCode < 0x007f)  {
    //     bytesCount++;
    // } else if ((0x0080 <= charCode) && (charCode <= 0x07ff))  {
    //     bytesCount += 2;
    // } else if ((0x0800 <= charCode) && (charCode <= 0xffff))  {
    //     bytesCount += 3;
    // } else{
    //     bytesCount += 4;
    // }
    if ((charCode >= 0x0001 && charCode <= 0x007e) || (0xff60 <= charCode && charCode <= 0xff9f)) {
      bytesCount += 1
    } else {
      bytesCount += 2
    }
    console.log(bytesCount)
  }
  return bytesCount
}

/**
 * 判断结果数据是否执行正常
 * @param {json} res
 */
export function isSuccess(res) {
  if (res.data == undefined) {
    res.data = []
  }
  if (res.code == 200) {
    return res.data
  }
}

/**
 * 检查用户是否具有指定的权限代码
 */
export function checkCode(code) {
  if (_global_.CODES) {
    return _global_.CODES.indexOf(code) != -1
  }
  return false
}

/**
 * 获取本地存储数据
 * @param {*} name
 */
export function getStorage(name) {
  return localStorage.getItem(name)
}

/**
 * 添加本地存储
 * @param {*} name
 * @param {*} val
 */
export function setStorage(name, val) {
  localStorage.setItem(name, val)
}

/**
 * 删除本地存储
 * @param {*} name
 */
export function removeStorage(name) {
  localStorage.removeItem(name)
}

/**
 * 获取Token信息
 */
export function getToken() {
  return getStorage(service_const.tokenKey)
}

/**
 * 判断用户是否登陆
 */
export function isLogin() {
  if (getToken() == null) {
    return false
  }
  return getToken().length != 0
}

/**
 * 打开登陆页面
 */
export function openLogin() {
  toUrl('/oauth/account-login')
}

/**
 * 刷新登陆信息(用户信息)
 */
export function refreshLoginInfo(fun) {
  api('auth.login.info').then((res) => {
    let data
    if ((data = isSuccess(res))) {
      _global_.LOGIN_INFO = data
      api('system.user.codes').then((res) => {
        _global_.CODES = res.data
      })
      if (fun != undefined) {
        fun()
      }
    }
  })
}
//将地址汉字转换成code
export function toCode(bA = [], fA = [], bs, bc, ba, fs, fc, fa) {
  let codeArr = {}
  let temp = TextToCode[bs]
  bA.push(temp == undefined ? '' : temp.code)
  if (temp != undefined) {
    temp = TextToCode[bs][bc]
    bA.push(temp == undefined ? '' : temp.code)
    if (temp != undefined) {
      temp = TextToCode[bs][bc][ba]
      bA.push(temp == undefined ? '' : temp.code)
    }
  }
  temp = TextToCode[fs]
  fA.push(temp == undefined ? '' : temp.code)
  if (temp != undefined) {
    temp = TextToCode[fs][fc]
    fA.push(temp == undefined ? '' : temp.code)
    if (temp != undefined) {
      temp = TextToCode[fs][fc][fa]
      fA.push(temp == undefined ? '' : temp.code)
    }
  }

  codeArr.beginAddress = bA
  codeArr.finishAddress = fA
  return codeArr
}
//将地址汉字转换成code
export function toCodeOne(bA = [], bs, bc, ba) {
  let codeArr = {}
  bA.push(TextToCode[bs].code)
  if (TextToCode[bs][bc]) {
    bA.push(TextToCode[bs][bc].code)
  }
  if (TextToCode[bs][bc][ba]) {
    bA.push(TextToCode[bs][bc][ba].code)
  }
  codeArr.beginAdd = bA
  return codeArr
}
//将地址code转换为汉字
export function toText(beginAddress = [bs, bc, ba], finishAddress = [fs, fc, fa]) {
  let Address = []
  Address[0] = CodeToText[beginAddress[0]]
  Address[1] = CodeToText[beginAddress[1]]
  Address[2] = CodeToText[beginAddress[2]]
  Address[3] = CodeToText[finishAddress[0]]
  Address[4] = CodeToText[finishAddress[1]]
  Address[5] = CodeToText[finishAddress[2]]
  return Address
}

//解决js丢失精度
export function accMul(arg1, arg2, fix) {
  if (!parseInt(fix) == fix) {
    return
  }
  var m = 0,
    s1 = arg1.toString(),
    s2 = arg2.toString()
  try {
    m += s1.split('.')[1].length
  } catch (e) {}
  try {
    m += s2.split('.')[1].length
  } catch (e) {}
  if (m > fix) {
    return Math.round((Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) / Math.pow(10, m - fix)) / Math.pow(10, fix)
  } else if (m <= fix) {
    return ((Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) / Math.pow(10, m)).toFixed(fix)
  } else {
    return (arg1 * arg2).toFixed(fix)
  }
}

/**
 * 银行列表
 */
export function getbankList() {
  let bank_list = [
    {
      label: '中国建设银行',
      value: 'CCB'
    },
    {
      label: '中国农业银行',
      value: 'ABC'
    },
    {
      label: '中国工商银行',
      value: 'ICBC'
    },
    {
      label: '中国银行',
      value: 'BOC'
    },
    {
      label: '中国民生银行',
      value: 'CMBC'
    },
    {
      label: '招商银行',
      value: 'CMB'
    },
    {
      label: '兴业银行',
      value: 'CIB'
    }
  ]
  return bank_list
}
// 把一个数组按照一定长度分割成若干数组
export function group(array, subGroupLength) {
  let index = 0
  let newArray = []
  while (index < array.length) {
    newArray.push(array.slice(index, (index += subGroupLength)))
  }
  return newArray
}
//阿拉伯数字转中文大写
export function DX(n) {
  if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(n)) return '数据非法'
  var unit = '京亿万仟佰拾兆万仟佰拾亿仟佰拾万仟佰拾元角分',
    str = ''
  n += '00'
  var p = n.indexOf('.')
  if (p >= 0) n = n.substring(0, p) + n.substr(p + 1, 2)
  unit = unit.substr(unit.length - n.length)
  for (var i = 0; i < n.length; i++) str += '零壹贰叁肆伍陆柒捌玖'.charAt(n.charAt(i)) + unit.charAt(i)
  return str
    .replace(/零(仟|佰|拾|角)/g, '零')
    .replace(/(零)+/g, '零')
    .replace(/零(兆|万|亿|元)/g, '$1')
    .replace(/(兆|亿)万/g, '$1')
    .replace(/(京|兆)亿/g, '$1')
    .replace(/(京)兆/g, '$1')
    .replace(/(京|兆|亿|仟|佰|拾)(万?)(.)仟/g, '$1$2零$3仟')
    .replace(/^元零?|零分/g, '')
    .replace(/(元|角)$/g, '$1整')
}
/**
 * 数据模型
 */
export const model = {
  /**
   * 图片上传模型
   * @param {*} title 标题
   * @param {*} controlType 类型[date|more|text]
   * @param {*} imageType 图片类型 DrivingLicense
   * @param {*} required 是否必需上传
   */

  //只传图片地址
  getModel: function(title, required, imageType) {
    return {
      _title: title,
      _required: required,
      image_url: '',
      pid: '',
      // 部分证件上传设有有背景图
      image_type: imageType
    }
  },

  getImageModel: function(title, controlType, imageType, required) {
    return {
      _title: title,
      _controlType: controlType,
      _required: required,
      image_type: imageType,
      image_url: '',
      indate: '',
      description: ''
    }
  },
  getImageModelByList(list) {
    let imageList = []
    list.forEach((item) => {
      let image = this.getImageModel('', 'date', item.image_type, true)
      image.image_url = item.image_url
      image.pid = item.pid
      image.description = item.description
      image.indate = item.indate
      switch (item.image_type) {
        case 'OtherTwo':
          image._title = '其他2'
          image._controlType = 'OtherTwo'
          image._required = false
          break
        case 'OtherOne':
          image._title = '其他1'
          image._controlType = 'OtherOne'
          image._required = false
          break
        case 'Other':
          image._title = '其他'
          image._controlType = 'more'
          image._required = false
          break
        case 'Contract':
          image._title = '合同'
          image._required = false
          break
        case 'Directive':
          image._title = '指令'
          image._required = false
          break
        case 'BusinessLicense':
          image._title = '道路运输证'
          image._required = true
          image.sort = 2
          break
        case 'IdCardFront':
          image._title = '身份证正面照'
          image._required = true
          image.sort = 0
          break
        case 'IdCardBack':
          image._title = '身份证反面照'
          image._required = false
          image.sort = 1
          break
        case 'QualificationCertificate':
          image._title = '从业资格证'
          image._required = false
          image.sort = 4
          break
        case 'DrivingLicense':
          image._title = '行驶证主页'
          image._required = true
          image.sort = 0
          break
        case 'DrivingLicenseFollower':
          image._title = '行驶证副页'
          image._required = false
          image.sort = 1
          break
        case 'RoadTransportBusinessLicense':
          image._title = '道路经营许可证'
          image._required = false
          image.sort = 3
          break
        case 'DriversLicense':
          image._title = '驾驶证'
          image._required = true
          image.sort = 2
          break
        case 'InsurancePolicy':
          image._title = '保险'
          image._required = false
          image.sort = 4
          break
        case 'QualityTesting':
          image._title = '船舶营运证'
          image._required = true
          break
        case 'NavigationCert':
          image._title = '船舶适航证'
          image._required = true
          break
        case 'CertificateOfCompetency':
          image._title = '适任证书'
          image._required = true
          break
        case 'Credentials':
          image._title = '合同资质证件证'
          image._required = false
          break
        case 'CarriageContract':
          image._title = '运输合同'
          image._required = true
          image.sort = 3
          break
        case 'RECEIPT':
          image._title = '回单'
          image._required = false
          break
        case 'HeadingCode':
          image._title = 'AIS标识码'
          image._required = false
          break
      }
      console.log(image.sort)
      imageList.push({
        ...item,
        ...image
      })
    })
    console.log(imageList, 'imageList')
    return imageList.sort((a, b) => a.sort - b.sort)
  }
}

export function doalogBlack(text, _this, e) {
  let type = true
  e == 'one' ? (type = false) : (type = true)
  if (_global_.LOGIN_INFO.is_black == 'Yes') {
    _this
      .$confirm(text, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
        if (type) toUrl('/')
      })
      .catch(() => {
        if (type) toUrl('/')
      })
    return false
  }
}

export function isValidDate(param) {
  if (!param) return false
  let date = new Date(param)
  return date instanceof Date && !isNaN(date.getTime())
}



// WEBPACK FOOTER //
// ./src/assets/js/utils.js